import * as CONSTANTS from 'constants';

const INIT_STATE = {
    inputModuleList: [],
    inputModuleTypes: [],
    inputModuleHeader: [
        {
            id: 0,
            title: 'comp.table.header.name',
            active: true,
            sortable: true,
            order: true,
            sortTitle: 'moduleName',
            mobile: true,
            width: 240,
            icon: true,
            style: { textAlign: 'left' }
        },
        {
            id: 1,
            title: 'comp.table.header.macAddress',
            active: false,
            sortable: true,
            order: true,
            mobile: true,
            width: 180,
            sortTitle: 'moduleMac',
            style: { textAlign: 'left' }
        },
        {
            id: 2,
            title: 'comp.table.header.noOfInputs',
            active: false,
            sortable: true,
            order: true,
            mobile: false,
            tablet: true,
            sortTitle: 'moduleCount',
            style: { textAlign: 'left' }
        }
    ],
    inputModuleDetails: null,
    requestStatus: CONSTANTS.INPUT_MODULE_REQUEST_IDLE
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CONSTANTS.SET_INPUT_MODULE_LIST: {
            return {
                ...state,
                inputModuleList: action.payload
            };
        }
        case CONSTANTS.SET_INPUT_MODULE_HEADERS: {
            return {
                ...state,
                inputModuleHeader: action.payload
            };
        }
        case CONSTANTS.SET_INPUT_MODULE_DETAILS: {
            return {
                ...state,
                inputModuleDetails: action.payload
            };
        }
        case CONSTANTS.UPDATE_INPUT_MODULE:
        case CONSTANTS.DELETE_INPUT_MODULE: {
            return {
                ...state,
                requestStatus: CONSTANTS.INPUT_MODULE_REQUEST_PENDING
            };
        }
        case CONSTANTS.SET_INPUT_MODULE_REQUEST_STATUS: {
            return {
                ...state,
                requestStatus: action.payload
            };
        }
        case CONSTANTS.SET_INPUT_MODULE_TYPES: {
            return {
                ...state,
                inputModuleTypes: action.payload
            };
        }
        default:
            return state;
    }
};
